module.exports = __webpack_public_path__ + "static/media/cuentas_old.f97b233c.svg";